import { SharedThirdPartyModule } from '@homeleite/shared-third-party';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonComponentsModule } from '@homeleite/common-components';
import { CommonPagesModule } from '@homeleite/common-pages';
import { MaterialModule } from 'libs/shared-third-party/src/lib/material/material.module';

const EXPORTED_MODULES = [
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  SharedThirdPartyModule,
  CommonComponentsModule,
  CommonPagesModule,
  MaterialModule
];

@NgModule({
  imports: [EXPORTED_MODULES],
  exports: [EXPORTED_MODULES],
})
export class DefaultSharedModule {}
